import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=04bffed4&scoped=true&"
import script from "./Lab.vue?vue&type=script&lang=js&"
export * from "./Lab.vue?vue&type=script&lang=js&"
import style0 from "./Lab.vue?vue&type=style&index=0&id=04bffed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bffed4",
  null
  
)

export default component.exports